import styled from "styled-components";
import logo from "../assets/images/logo.png";

function Header({logo, campaignSetting}){

    const customColors = campaignSetting?.site_settings?.custom_colors;
    // 메뉴 열림 상태와 동일하게 사용
    return(
        <Container 
            primaryColor={customColors?.primary}
            accentColor={customColors?.accent}
        >
            <Logo src={logo?.downloadURL} />
            {/* <BurgerButton
                src={burger}
                onClick={() => setRotated(r => !r)}
                rotated={rotated}
                alt="burger menu"
            />
            <Menu open={rotated}>
                <ul>
                    <li>홈</li>
                    <li>소개</li>
                    <li>서비스</li>
                    <li>문의</li>
                </ul>
            </Menu> */}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100vw;
    background-color: ${props => props.primaryColor};
    color: #fff;
    padding: 0 20px;
    height: 70px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
    transition: background-color 0.3s ease;
`

const Logo = styled.img`
    height: 100%;
`
export default Header;